import $ from 'jquery';
import "./animation";

const mobile_menu = $('.nav-mobile')
const menu_toggler = $('.header-mobile__toggle')
const header = $('.header');
const wrapper = $('.wrapper')
const search_form = $('.nav-search .wrapper')
const body = $('body')
const scrolled_content = $('.scroll-content')
const item_has_submenu = $('.nav-mobile__wrapper .menu-item-has-children > a')
const nav_mobile_toggler = $('.nav-mobile__toggler')

function openMobileMenu() {
  menu_toggler.click(function () {
    mobile_menu.slideDown(300)
    header.addClass('open-mobile-menu')
    body.addClass('hidden')
    body.prepend(header);
  })
}
openMobileMenu()


function closeMobileMenu() {
  nav_mobile_toggler.click(function() {
    mobile_menu.slideUp(300)
    setTimeout(function() {
      header.removeClass('open-mobile-menu')
    }, 300)
    body.removeClass('hidden')
    scrolled_content.prepend(header)
  })
}
closeMobileMenu()

item_has_submenu.click(function(e) {
  e.preventDefault()
  $(this).next().slideToggle()
})

$('.nav-main .menu-item-has-children > a').click(function(e) {
  e.preventDefault()
  search_form.addClass('disable-form')
})

$('.nav-main .menu-item-has-children').hover(
  function() {
    $(this).addClass('submenu-active')
    $(this).find('ul').slideDown({duration:200, easing:"swing"})
    $(this).find('a').addClass('link-opacity')
    wrapper.fadeIn({duration:200, easing:"swing"})
    search_form.fadeIn({duration:200, easing:"swing"})
  }, function() {
    $(this).removeClass('submenu-active')
    $(this).find('ul').slideUp({duration:200, easing:"swing"} )
    $(this).find('a').removeClass('link-opacity')
    wrapper.fadeOut({duration:200, easing:"swing"})
    search_form.fadeOut({duration:200, easing:"swing"})
  }
);

const submenu = $('.nav-main > ul > li > ul');

submenu.wrap('<ul class="nav-main__submenu" </ul>')

